import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ArticlePrice, ArticlePriceLookup } from '../../model';
import { Occ } from '../../occ';
import { ConverterService, UuidService } from '../../util';
import { ARTICLE_PRICE_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class PriceConnector {
  private readonly optiSessionIndicatorHeaderKey = 'X-opti-session-indicator';
  private headers: HttpHeaders;

  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
    private uuidService: UuidService,
    private authService: AuthService
  ) {
    this.headers = new HttpHeaders().append(this.optiSessionIndicatorHeaderKey, this.uuidService.getUniqueId(6));
  }

  getSynchronousPrice(input: ArticlePriceLookup): Observable<ArticlePrice> {
    const url = this.occEndpointsService.buildUrl('price', {
      urlParams: { userId: input.userId },
      queryParams: {
        articleNumber: input.articleNumber,
        quantity: input.quantity,
        unit: input.unit,
      },
    });

    return this.authService.isUserLoggedIn().pipe(
      switchMap((isLoggedIn) =>
        this.httpClient
          .get(url, { headers: !isLoggedIn ? this.headers : {} })
          .pipe(this.converterService.pipeable(ARTICLE_PRICE_NORMALIZER))
      ),
      take(1)
    );
  }

  getAsynchronousPrices(input: Array<ArticlePriceLookup>): Observable<Array<ArticlePrice>> {
    const url = this.occEndpointsService.buildUrl('prices', { urlParams: { userId: input[0].userId } });

    return this.authService.isUserLoggedIn().pipe(
      switchMap((isLoggedIn) =>
        this.httpClient
          .post<Occ.PriceResponseList>(url, { priceRequests: input }, { headers: !isLoggedIn ? this.headers : {} })
          .pipe(
            map((response) => response.priceResponses),
            this.converterService.pipeableMany(ARTICLE_PRICE_NORMALIZER)
          )
      ),
      take(1)
    );
  }
}
